import React from "react";

const RadioButtonsGroup = ({ register, setDps, setChecked, name, id, disabled=false, checked }) => {

  const handle = (e) => {
    setDps(e.target.value === "true");
    if (e.target.value === "true") {
      setChecked(false);
    }
  };

  return (
    <div className="wapperRadioButton">
      <div className="wapperRadioButton__dolar">
        <label htmlFor={`success_dps_${id}`}>
          <input
            type="radio"
            name={name}
            id={`success_dps_${id}`}
            value={true}
            onChange={handle}
            disabled={disabled}
            ref={register}
          
            checked={checked ? true : null}
          />
          <span>Si</span>
        </label>
      </div>
      <div className="wapperRadioButton__soles">
        <label htmlFor={`denied_dps_${id}`}>
          <input
            type="radio"
            name={name}
            id={`denied_dps_${id}`}
            value={false}
            onChange={handle}
            disabled={disabled}
            ref={register}
            checked={!checked ? true : null}
          />
          <span>No</span>
        </label>
      </div>
    </div>
  );
};

export default RadioButtonsGroup;
